import { render, staticRenderFns } from "./AllOrgs.vue?vue&type=template&id=fcff6116&"
import script from "./AllOrgs.vue?vue&type=script&lang=js&"
export * from "./AllOrgs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports